import React from 'react'
import type { Location } from 'react-router-dom'
import { RxLightningBolt } from '@react-icons/all-files/rx/RxLightningBolt'
import type mixpanelClient from '@disco/api/mixpanel'
import type { Track } from 'types/track'
import { Flex } from 'components/ds'
import ActionTitleWithBadge from 'components/track-actions/action-title-with-badge'
import Submenu from 'components/track-actions/submenu/dropdown-submenu'
import AudioSeparationMenuOption from './audio-separation-menu-option'
import LyricTranscription from './lyric-transcription'

type Props = {
  track: Track
  isAutoTagged: boolean
  audioSeparationEnabled: boolean
  audioSeparationTermsAccepted: boolean
  location?: Location
  closeMenu: () => void
  mixpanelContext: string
  mixpanel: typeof mixpanelClient
  audioSeparationVisible: boolean
  isLyricsTranscriptionEnabled: boolean
}

const AIToolsMenuOption = (props: Props): React.ReactNode => {
  const showAudioSeparation =
    props.audioSeparationVisible ||
    props.audioSeparationTermsAccepted ||
    props.audioSeparationEnabled

  const links: React.ReactNode[] = []
  if (showAudioSeparation) {
    links.push(
      <AudioSeparationMenuOption
        key="instant-instrumental"
        type="instrumental"
        track={props.track}
        enabled={props.audioSeparationEnabled}
        isAutoTagged={props.isAutoTagged}
        audioSeparationTermsAccepted={props.audioSeparationTermsAccepted}
        location={props.location}
        closeMenu={props.closeMenu}
        mixpanelContext={props.mixpanelContext}
        mixpanel={props.mixpanel}
      />,
      <AudioSeparationMenuOption
        key="instant-a-cappella"
        type="vocals"
        track={props.track}
        enabled={props.audioSeparationEnabled}
        isAutoTagged={props.isAutoTagged}
        audioSeparationTermsAccepted={props.audioSeparationTermsAccepted}
        location={props.location}
        closeMenu={props.closeMenu}
        mixpanelContext={props.mixpanelContext}
        mixpanel={props.mixpanel}
      />,
    )
  }
  if (props.isLyricsTranscriptionEnabled)
    links.push(
      <LyricTranscription
        key="lyric-transcription"
        closeMenu={props.closeMenu}
        track={props.track}
      />,
    )
  if (!links.length) return null

  return (
    <Submenu
      title={
        <Flex align="center" gap="2">
          <RxLightningBolt />
          <ActionTitleWithBadge title="AI tools" badgeText="New" />
        </Flex>
      }
      links={links}
    />
  )
}

export default AIToolsMenuOption
